/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";

import {
  QuestionCircleOutlined,
  CloseCircleOutlined,
  FrownOutlined,
} from "@ant-design/icons";
import { Button, Modal, notification } from "antd";

import useScheduleSystems from "../../../hooks/useScheduleSystems";

function DeleteScene({ interval }) {
  const [isOpen, setIsOpen] = useState(false);
  const { scheduleSystems, setScheduleSystems } = useScheduleSystems();

  const { interval: data } = interval;
  const { startTime, name } = data;

  const handleDeleteScene = () => {
    const filteredScheduleIntervals = scheduleSystems.scheduleIntervals.filter(
      (intervalItem) => intervalItem.startTime !== startTime,
    );
    setScheduleSystems({
      ...scheduleSystems,
      scheduleIntervals: filteredScheduleIntervals,
    });

    if (filteredScheduleIntervals.length === 0) {
      notification.error({
        message: (
          <span className="uppercase tracking-widest">
            Cannot delete the Scene
          </span>
        ),
        description:
          "You cannot delete the only Scene you have in the Schedule.",
        placement: "topRight",
        icon: <FrownOutlined className="text-triple-red" />,
        duration: 0,
      });
    }
  };
  const isDisabled = scheduleSystems.scheduleIntervals.length === 1;

  return (
    <>
      <Button type="link" className="text-lg" onClick={() => setIsOpen(true)}>
        <CloseCircleOutlined />
      </Button>
      <Modal
        open={isOpen}
        width={584}
        footer={[
          <Button
            key="cancel-scene-delete"
            size="large"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>,
          <Button
            key="confirm-scene-delete"
            type="primary"
            size="large"
            onClick={handleDeleteScene}
            disabled={isDisabled}
          >
            Delete
          </Button>,
        ]}
        onCancel={() => setIsOpen(false)}
      >
        <div className="p-8 flex flex-col items-center">
          <QuestionCircleOutlined className="text-triple-blue text-3xl mb-4" />
          <h1 className="text-white uppercase tracking-widest text-xl font-light text-center">
            Are you sure you want to delete this scene?
          </h1>
        </div>

        <div className="pb-16 px-4">
          <h3 className="text-center mb-4">{name || "Unknown Scene"}</h3>
        </div>
      </Modal>
    </>
  );
}

export default DeleteScene;
